<template>
  <v-container fluid id="tf-problem" class="tf-problem-section py-8 py-md-16">
    <v-container>

      <v-row class="mb-10">
        <v-col cols="12" class="text-center">
          <span
            class="overline font-weight-bold"
            :style="{ color: '#00695C' }"
            data-aos="fade-down"
          >
            EL PROBLEMA
          </span>
          <h2
            class="display-1 font-weight-bold primary--text mt-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            El caos que frena tu operación de
            comercio exterior
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col
          v-for="(problem, i) in problems"
          :key="i"
          cols="12"
          sm="6"
          md="4"
          data-aos="fade-up"
          :data-aos-delay="String(i * 100)"
        >
          <v-card class="tf-problem-card pa-6 h-100" elevation="2">
            <v-avatar
              size="56"
              class="mb-4"
              :style="{ backgroundColor: '#00695C1A' }"
            >
              <v-icon color="#00695C" size="28">
                {{ problem.icon }}
              </v-icon>
            </v-avatar>
            <v-card-text class="pa-0">
              <h3 class="text-h6 font-weight-bold primary--text mb-2">
                {{ problem.title }}
              </h3>
              <p class="body-2 greylight--text mb-0">
                {{ problem.description }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'TFProblem',
  data() {
    return {
      problems: [
        {
          icon: 'mdi-file-document-multiple',
          title: 'Armado manual de BLs',
          description: 'Copias y correcciones manuales de Bills of Lading entre correo, WhatsApp y Excel generan errores y retrasos en cada embarque.',
        },
        {
          icon: 'mdi-map-search',
          title: 'Rastreo de pedimentos por teléfono',
          description: 'Llamadas al agente aduanal para saber el estatus de cada pedimento. Sin visibilidad en tiempo real, sin historial centralizado.',
        },
        {
          icon: 'mdi-cash-multiple',
          title: 'Aprobaciones de flete por WhatsApp',
          description: 'Cotizaciones y aprobaciones de gastos de flete enterradas en chats. Imposible auditar o comparar costos por operación.',
        },
        {
          icon: 'mdi-clipboard-check-multiple',
          title: 'Revisión manual de facturas contra pedimentos',
          description: 'Conciliación línea a línea entre facturas comerciales y pedimentos de importación consume horas y genera errores de captura.',
        },
        {
          icon: 'mdi-account-tie',
          title: 'Coordinación dispersa con el agente aduanal',
          description: 'Instrucciones al agente aduanal por múltiples canales. Sin trazabilidad de quién aprobó qué ni cuándo.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tf-problem-section {
  background-color: #F5F5F5;
}

.tf-problem-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
}

.tf-problem-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 105, 92, 0.15) !important;
}

</style>
